import { FC } from "react";

const DEFAULT_LAYERS_ICON_SIZE_PX = 20;

interface IMapLibreLayersIconProps {
  /** Rendered square size in px. */
  size?: number;
  /** Fill color; defaults to `currentColor` so the parent's `color` drives it. */
  color?: string;
  className?: string;
}

/** Stacked-layers glyph for the base-tile selector toggle (prop-driven, extendable). */
export const MapLibreLayersIcon: FC<IMapLibreLayersIconProps> = ({
  size = DEFAULT_LAYERS_ICON_SIZE_PX,
  color = "currentColor",
  className,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M12 2 1 8l11 6 11-6-11-6Zm7.9 8.1L23 11.6l-11 6-11-6 3.1-1.5L12 14l7.9-3.9Z" />
  </svg>
);
